import HomeBanner from '../LandingPage/HomeBanner'
import HomeBigimage from '../LandingPage/HomeBigimage'
import HomeConnect from '../LandingPage/HomeConnect'
import HomeCounter from '../LandingPage/HomeCounter'
import HomeFounder from '../LandingPage/HomeFounder'
import HomeManufacture from '../LandingPage/HomeManufacture'
import HomeProject from '../LandingPage/HomeProject'
import HomeService from '../LandingPage/HomeService'
import HomeTestimonial from '../LandingPage/HomeTestimonial'
import LandingForm from './LandingForm'
import LandingGallery from './LandingGallery'

export default function Home({ initialData }) {
  return (
    <>
      <HomeBanner/>
      <HomeFounder/>
      <HomeProject initialProjects={initialData?.projects} />
      <HomeService/>
      <LandingForm/>
      <HomeTestimonial/>
      <LandingGallery/>
      <HomeCounter/>
      <HomeManufacture/> 
      <HomeBigimage/>
      <HomeConnect/>
    </>
  )
}
